<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('studentTransfer.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('studentTransfer.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-4">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'transfer-create' })"
              >{{ $t('add_new') }}</ts-button
            >
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 300px"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-loading-banner :loading="exporting">
          <Table
            :columns="columns"
            :data="resources"
            :loading="loading"
            max-height="700"
            stripe
            highlight-row
            size="small"
          >
            <template slot-scope="{ row }" slot="full_name_en">
              {{ row.student ? row.student.full_name_en : '' }}
            </template>
            <template slot-scope="{ row }" slot="from_branch_name_en">
              {{ row.from_branch ? row.from_branch.branch_name_en : '' }}
            </template>
            <template slot-scope="{ row }" slot="to_branch_name_en">
              {{
                row.to_branch
                  ? row.to_branch.branch_name_en
                  : row.from_branch.branch_name_en
              }}
            </template>
            <template slot-scope="{ row }" slot="from_class_info">
              {{
                row.from_class.class_name +
                  '_' +
                  (row.from_class.academic_study_time
                    ? row.from_class.academic_study_time.study_time
                    : '') +
                  '_' +
                  (row.from_class.teacher
                    ? row.from_class.teacher.full_name_en
                    : '')
              }}
            </template>
            <template slot-scope="{ row }" slot="to_class_info">
              {{
                row.to_class.class_name +
                  '_' +
                  (row.to_class.academic_study_time
                    ? row.to_class.academic_study_time.study_time
                    : '') +
                  '_' +
                  (row.to_class.teacher
                    ? row.to_class.teacher.full_name_en
                    : '')
              }}
            </template>
          </Table>
        </ts-loading-banner>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './create'
import EditFormComponent from './edit'
export default {
  name: 'studentTransfer',
  data() {
    return {
      loading: false,
      exporting: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('studentTransfer', ['resources', 'pagination']),
    columns() {
      return [
        {
          title: this.$t('studentTransfer.studentName'),
          slot: 'full_name_en',
          minWidth: 80
        },
        {
          title: this.$t('studentTransfer.date'),
          key: 'transfered_date',
          minWidth: 60
        },
        {
          title: this.$t('studentTransfer.fromBranch'),
          slot: 'from_branch_name_en',
          minWidth: 40
        },
        {
          title: this.$t('studentTransfer.toBranch'),
          slot: 'to_branch_name_en',
          minWidth: 40
        },
        {
          title: this.$t('studentTransfer.fromClass'),
          slot: 'from_class_info',
          minWidth: 120
        },
        {
          title: this.$t('studentTransfer.toClass'),
          slot: 'to_class_info',
          minWidth: 120
        },
        {
          title: this.$t('studentTransfer.comment'),
          key: 'comment',
          minWidth: 80
        }
      ]
    },
    search: {
      get() {
        return this.$store.state.studentTransfer.search
      },
      set(newValue) {
        this.$store.commit('studentTransfer/SET_SEARCH', newValue)
        this.$store.commit('studentTransfer/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    showEditForm(editData) {
      this.$modal.show(
        EditFormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '580px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('studentTransfer/fetch', attributes)
        .then(() => {
          this.loading = false
        })
        .catch(errors => {
          this.loading = false
          this.$toasted.error(errors.message)
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('studentTransfer/RESET_STATE')
    next()
  }
}
</script>
